import { render, staticRenderFns } from "./suspectUserPop.vue?vue&type=template&id=4a8afb04"
import script from "./suspectUserPop.vue?vue&type=script&lang=js"
export * from "./suspectUserPop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4a8afb04')) {
      api.createRecord('4a8afb04', component.options)
    } else {
      api.reload('4a8afb04', component.options)
    }
    module.hot.accept("./suspectUserPop.vue?vue&type=template&id=4a8afb04", function () {
      api.rerender('4a8afb04', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/hea/suspectUserPop.vue"
export default component.exports